module.exports = {
     None: 0,
     Brown: 1,
     Silver: 2,
     Gold: 3,
     Platinum: 4
}